export enum MappingStatusEnum {
  NULL = '',
  MAPPED = 'Mapped',
  UNMAPPED = 'Unmapped', //Obsolete with https://fitogram.atlassian.net/browse/CS-267
  IN_PROCESS = 'InProcess', //Obsolete with https://fitogram.atlassian.net/browse/CS-267
  UNDER_REVIEW = 'UnderReview', //Replaces IN_PROCESS with https://fitogram.atlassian.net/browse/CS-267
}

export enum ExternalPartyID {
  USC_INTEGRATION = 1,
  ONE_FIT = 3,
}

export type IExternalParty = {
  id: ExternalPartyID;
  name: string;
  enabled: boolean;
};

export enum LocationStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  AwaitingApproval = 'AwaitingApproval',
  Paused = 'Paused',
  Terminated = 'Terminated',
}

export enum ChannelStatus {
  active = 'active',
  inactive = 'inactive',
  uninitialized = 'uninitialized',
}

export interface IExternalPartyLocation {
  locationId: string;
  venueId?: string;
  locationMappingStatus: MappingStatusEnum;
  checkInUrl: string;
  liveStreamEnabled: boolean;
  externalPartyId: number;
  integrationDate: string;
  integrationType: string;
  state?: LocationStatus;
}
